"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Auth-service API
 * API for Auth Service
 *
 * The version of the OpenAPI document: 2.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Required scope: auth-user-role-create
         * @summary Adds roles to a user
         * @param {string} userUuid
         * @param {UserRoleCreateDTO} userRoleCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleForUser: (userUuid, userRoleCreateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('addRoleForUser', 'userUuid', userUuid);
            // verify required parameter 'userRoleCreateDTO' is not null or undefined
            (0, common_1.assertParamExists)('addRoleForUser', 'userRoleCreateDTO', userRoleCreateDTO);
            const localVarPath = `/users/{userUuid}/roles`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userRoleCreateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-user-create
         * @summary Assign a user to a group
         * @param {string} groupUuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUserToGroup: (groupUuid, userUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('assignUserToGroup', 'groupUuid', groupUuid);
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('assignUserToGroup', 'userUuid', userUuid);
            const localVarPath = `/groups/{groupUuid}/users/{userUuid}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)))
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-role-scope-create
         * @summary Associates a scope to a role
         * @param {string} uuid
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateRoleToScope: (uuid, scopeUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('associateRoleToScope', 'uuid', uuid);
            // verify required parameter 'scopeUuid' is not null or undefined
            (0, common_1.assertParamExists)('associateRoleToScope', 'scopeUuid', scopeUuid);
            const localVarPath = `/roles/{uuid}/scopes/{scopeUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"scopeUuid"}}`, encodeURIComponent(String(scopeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-role-scope-create
         * @summary Associates a role to a scope
         * @param {string} uuid
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateScopeToRole: (uuid, roleUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('associateScopeToRole', 'uuid', uuid);
            // verify required parameter 'roleUuid' is not null or undefined
            (0, common_1.assertParamExists)('associateScopeToRole', 'roleUuid', roleUuid);
            const localVarPath = `/scopes/{uuid}/roles/{roleUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"roleUuid"}}`, encodeURIComponent(String(roleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-role-create
         * @summary Bulk creates roles
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateRoles: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('bulkCreateRoles', 'requestBody', requestBody);
            const localVarPath = `/roles/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-scope-create
         * @summary Bulk creates scopes
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateScopes: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('bulkCreateScopes', 'requestBody', requestBody);
            const localVarPath = `/scopes/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Consumes an existing verification token, authenticating the User to whom it was associated
         * @param {VerificationTokenConsumeRequestDTO} verificationTokenConsumeRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeVerificationToken: (verificationTokenConsumeRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'verificationTokenConsumeRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('consumeVerificationToken', 'verificationTokenConsumeRequestDTO', verificationTokenConsumeRequestDTO);
            const localVarPath = `/verification-tokens/consume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verificationTokenConsumeRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-group-create
         * @summary Creates a group
         * @param {GroupCreateDto} groupCreateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: (groupCreateDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupCreateDto' is not null or undefined
            (0, common_1.assertParamExists)('createGroup', 'groupCreateDto', groupCreateDto);
            const localVarPath = `/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(groupCreateDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-profile-create, auth-profile-update
         * @summary Creates or updates a profile for a user
         * @param {string} userUuid
         * @param {ProfileCreateOrUpdateDTO} profileCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateUserProfile: (userUuid, profileCreateOrUpdateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('createOrUpdateUserProfile', 'userUuid', userUuid);
            // verify required parameter 'profileCreateOrUpdateDTO' is not null or undefined
            (0, common_1.assertParamExists)('createOrUpdateUserProfile', 'profileCreateOrUpdateDTO', profileCreateOrUpdateDTO);
            const localVarPath = `/users/{userUuid}/profile`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(profileCreateOrUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-role-create
         * @summary Creates a role
         * @param {RoleCreateOrUpdateDTO} roleCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: (roleCreateOrUpdateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'roleCreateOrUpdateDTO' is not null or undefined
            (0, common_1.assertParamExists)('createRole', 'roleCreateOrUpdateDTO', roleCreateOrUpdateDTO);
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roleCreateOrUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-scope-create
         * @summary Creates a new scope
         * @param {ScopeCreateOrUpdateDTO} scopeCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScope: (scopeCreateOrUpdateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'scopeCreateOrUpdateDTO' is not null or undefined
            (0, common_1.assertParamExists)('createScope', 'scopeCreateOrUpdateDTO', scopeCreateOrUpdateDTO);
            const localVarPath = `/scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scopeCreateOrUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-create
         * @summary Creates a new user
         * @param {UserCreateOrUpdateDTO} userCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: (userCreateOrUpdateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userCreateOrUpdateDTO' is not null or undefined
            (0, common_1.assertParamExists)('createUser', 'userCreateOrUpdateDTO', userCreateOrUpdateDTO);
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userCreateOrUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-create
         * @summary Bulk creates users
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsers: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('createUsers', 'requestBody', requestBody);
            const localVarPath = `/users/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-delete
         * @summary Delete a group
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: (groupUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteGroup', 'groupUuid', groupUuid);
            const localVarPath = `/groups/{groupUuid}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-external-ref-delete
         * @summary Delete an external ref associated with this group.
         * @param {string} groupUuid
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupExternalRef: (groupUuid, type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteGroupExternalRef', 'groupUuid', groupUuid);
            // verify required parameter 'type' is not null or undefined
            (0, common_1.assertParamExists)('deleteGroupExternalRef', 'type', type);
            const localVarPath = `/groups/{groupUuid}/external/{type}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-role-delete
         * @summary Deletes a role
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteRole', 'uuid', uuid);
            const localVarPath = `/roles/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-role-delete
         * @summary Deletes a role from a user
         * @param {string} userUuid
         * @param {string} userRoleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleForUser: (userUuid, userRoleUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteRoleForUser', 'userUuid', userUuid);
            // verify required parameter 'userRoleUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteRoleForUser', 'userRoleUuid', userRoleUuid);
            const localVarPath = `/users/{userUuid}/roles/{userRoleUuid}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)))
                .replace(`{${"userRoleUuid"}}`, encodeURIComponent(String(userRoleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-role-scope-delete
         * @summary Deletes a scope\'s association to a role
         * @param {string} uuid
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleToScopeAssociation: (uuid, scopeUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteRoleToScopeAssociation', 'uuid', uuid);
            // verify required parameter 'scopeUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteRoleToScopeAssociation', 'scopeUuid', scopeUuid);
            const localVarPath = `/roles/{uuid}/scopes/{scopeUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"scopeUuid"}}`, encodeURIComponent(String(scopeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-scope-delete
         * @summary Deletes a scope
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScope: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteScope', 'uuid', uuid);
            const localVarPath = `/scopes/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-role-scope-delete
         * @summary Deletes an association between a role and a scope
         * @param {string} uuid
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScopeToRoleAssociation: (uuid, roleUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteScopeToRoleAssociation', 'uuid', uuid);
            // verify required parameter 'roleUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteScopeToRoleAssociation', 'roleUuid', roleUuid);
            const localVarPath = `/scopes/{uuid}/roles/{roleUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"roleUuid"}}`, encodeURIComponent(String(roleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-delete
         * @summary Deletes a user
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteUser', 'uuid', uuid);
            const localVarPath = `/users/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-user-delete
         * @summary Deletion of a user from a group
         * @param {string} groupUuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserFromGroup: (groupUuid, userUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteUserFromGroup', 'groupUuid', groupUuid);
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteUserFromGroup', 'userUuid', userUuid);
            const localVarPath = `/groups/{groupUuid}/users/{userUuid}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)))
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-profile-delete
         * @summary Deletes a profile for a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserProfile: (userUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('deleteUserProfile', 'userUuid', userUuid);
            const localVarPath = `/users/{userUuid}/profile`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnosisCheck: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/diagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-user-external-ref-read.
         * @summary Get a user by external ref type and external ref id
         * @param {string} externalType
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserByExternalRef: (externalType, externalId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalType' is not null or undefined
            (0, common_1.assertParamExists)('findUserByExternalRef', 'externalType', externalType);
            // verify required parameter 'externalId' is not null or undefined
            (0, common_1.assertParamExists)('findUserByExternalRef', 'externalId', externalId);
            const localVarPath = `/users/external/{externalType}/{externalId}`
                .replace(`{${"externalType"}}`, encodeURIComponent(String(externalType)))
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-search Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Search for users by user or profile info
         * @param {UserFindDTO} userFindDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsers: (userFindDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userFindDTO' is not null or undefined
            (0, common_1.assertParamExists)('findUsers', 'userFindDTO', userFindDTO);
            const localVarPath = `/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userFindDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * No scope requirements
         * @summary Generates a QR code that can be used to setup/enable MFA
         * @param {GenerateMfaTokenRequestDto} generateMfaTokenRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMfaToken: (generateMfaTokenRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateMfaTokenRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('generateMfaToken', 'generateMfaTokenRequestDto', generateMfaTokenRequestDto);
            const localVarPath = `/login/mfa/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generateMfaTokenRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Requests token generation
         * @param {VerificationTokenGenerateRequestDTO} verificationTokenGenerateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVerificationToken: (verificationTokenGenerateRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'verificationTokenGenerateRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('generateVerificationToken', 'verificationTokenGenerateRequestDTO', verificationTokenGenerateRequestDTO);
            const localVarPath = `/verification-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verificationTokenGenerateRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-role-read
         * @summary Get all roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-scope-read
         * @summary Returns all scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScopes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the current user record, optionally including the profile and roles. This is needed for users to fetch their own info; The get-user-by-ID endpoint is not useful in this case since users do not yet know their IDs.
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: (include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'include' is not null or undefined
            (0, common_1.assertParamExists)('getCurrentUser', 'include', include);
            const localVarPath = `/users/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-read
         * @summary Get a group by ID
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: (groupUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('getGroup', 'groupUuid', groupUuid);
            const localVarPath = `/groups/{groupUuid}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-user-list Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Returns a list of users for a group
         * @param {string} groupUuid
         * @param {number} page
         * @param {string} [username] Presence: optional
         * @param {string} [firstName] Presence: optional
         * @param {string} [lastName] Presence: optional
         * @param {string} [email] Presence: optional
         * @param {string} [roleName] Provide a Role Name which should be present for returned Principals.&lt;br&gt;Presence: optional
         * @param {Array<string>} [context] Indicate context properties which should be matched using key:value strings.
         * @param {boolean} [recursive] Indicate whether groups should be scanned recursively.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupUsers: (groupUuid, page, username, firstName, lastName, email, roleName, context, recursive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('getGroupUsers', 'groupUuid', groupUuid);
            // verify required parameter 'page' is not null or undefined
            (0, common_1.assertParamExists)('getGroupUsers', 'page', page);
            const localVarPath = `/groups/{groupUuid}/users`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (roleName !== undefined) {
                localVarQueryParameter['roleName'] = roleName;
            }
            if (context) {
                localVarQueryParameter['context'] = context;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-list Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new groups added). This means that a record appearing at the end of a page might appear again on the following page, or a group at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Fetch the groups in the system, optionally filtering by name, category, or parent group ID
         * @param {number} [page] Presence: optional
         * @param {string} [name] Presence: optional
         * @param {string} [category] Presence: optional; nullable
         * @param {string} [parentUuid] Presence: optional; nullable
         * @param {string} [externalType] Presence: optional
         * @param {string} [externalId] Presence: optional
         * @param {boolean} [includeAddress] Presence: optional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: (page, name, category, parentUuid, externalType, externalId, includeAddress, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            if (parentUuid !== undefined) {
                localVarQueryParameter['parentUuid'] = parentUuid;
            }
            if (externalType !== undefined) {
                localVarQueryParameter['externalType'] = externalType;
            }
            if (externalId !== undefined) {
                localVarQueryParameter['externalId'] = externalId;
            }
            if (includeAddress !== undefined) {
                localVarQueryParameter['includeAddress'] = includeAddress;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-role-read, auth-role-scope-read, auth-scope-read
         * @summary Gets a role
         * @param {string} uuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: (uuid, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('getRole', 'uuid', uuid);
            // verify required parameter 'include' is not null or undefined
            (0, common_1.assertParamExists)('getRole', 'include', include);
            const localVarPath = `/roles/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-role-scope-read, auth-role-read
         * @summary Gets roles for a scope
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForScope: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('getRolesForScope', 'uuid', uuid);
            const localVarPath = `/scopes/{uuid}/roles`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-user-role-read
         * @summary Gets roles for a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForUser: (userUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('getRolesForUser', 'userUuid', userUuid);
            const localVarPath = `/users/{userUuid}/roles`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-scope-read
         * @summary Returns a specific scope
         * @param {string} uuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScope: (uuid, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('getScope', 'uuid', uuid);
            // verify required parameter 'include' is not null or undefined
            (0, common_1.assertParamExists)('getScope', 'include', include);
            const localVarPath = `/scopes/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-role-scope-read, auth-scope-read
         * @summary Gets scopes for a role
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopesForRole: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('getScopesForRole', 'uuid', uuid);
            const localVarPath = `/roles/{uuid}/scopes`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-user-read. Optional scopes: auth-user-role-read, auth-profile-read
         * @summary Get a user by ID
         * @param {string} userUuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: (userUuid, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('getUserById', 'userUuid', userUuid);
            // verify required parameter 'include' is not null or undefined
            (0, common_1.assertParamExists)('getUserById', 'include', include);
            const localVarPath = `/users/{userUuid}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets user context for a token
         * @param {UserContextRequestDto} userContextRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContext: (userContextRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userContextRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('getUserContext', 'userContextRequestDto', userContextRequestDto);
            const localVarPath = `/user-context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userContextRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets user context for a PAPI/AUTH token
         * @param {UserContextRequestDto} userContextRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContextForCommercial: (userContextRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userContextRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('getUserContextForCommercial', 'userContextRequestDto', userContextRequestDto);
            const localVarPath = `/user-context/commercial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userContextRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets user context for a sapi token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContextForStudy: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/user-context/study`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-group-list
         * @summary Fetch the groups to which the given user belongs
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroups: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('getUserGroups', 'uuid', uuid);
            const localVarPath = `/users/{uuid}/groups`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-list-all Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Search for users by user or profile info
         * @param {number} [page] Presence: optional
         * @param {string} [username] Presence: optional
         * @param {string} [firstName] Presence: optional
         * @param {string} [lastName] Presence: optional
         * @param {string} [email] Presence: optional
         * @param {string} [mobilePhone] Presence: optional
         * @param {string} [birthDate] Presence: optional
         * @param {string} [papiId] Presence: optional
         * @param {string} [sapiId] Presence: optional
         * @param {string} [roleId] Presence: optional
         * @param {string} [groupUuid] Presence: optional
         * @param {boolean} [includeSubGroups] Presence: optional
         * @param {string} [roleName] Presence: optional
         * @param {'permissions' | 'profile'} [include] Presence: optional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: (page, username, firstName, lastName, email, mobilePhone, birthDate, papiId, sapiId, roleId, groupUuid, includeSubGroups, roleName, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (mobilePhone !== undefined) {
                localVarQueryParameter['mobilePhone'] = mobilePhone;
            }
            if (birthDate !== undefined) {
                localVarQueryParameter['birthDate'] = birthDate;
            }
            if (papiId !== undefined) {
                localVarQueryParameter['papiId'] = papiId;
            }
            if (sapiId !== undefined) {
                localVarQueryParameter['sapiId'] = sapiId;
            }
            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }
            if (groupUuid !== undefined) {
                localVarQueryParameter['groupUuid'] = groupUuid;
            }
            if (includeSubGroups !== undefined) {
                localVarQueryParameter['includeSubGroups'] = includeSubGroups;
            }
            if (roleName !== undefined) {
                localVarQueryParameter['roleName'] = roleName;
            }
            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-search. Max UUIDs: 20.
         * @summary Returns an array of users with the given UUIDs
         * @param {Array<string>} uuid A single UUID or an array of UUIDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersById: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('getUsersById', 'uuid', uuid);
            const localVarPath = `/users-by-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (uuid) {
                localVarQueryParameter['uuid'] = uuid;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes:       auth-audit-delete,       auth-group-delete,       auth-hard-delete
         * @summary Hard deletes a group
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteGroup: (groupUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('hardDeleteGroup', 'groupUuid', groupUuid);
            const localVarPath = `/admin/groups/{groupUuid}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes:       auth-audit-delete,       auth-role-delete,       auth-hard-delete
         * @summary Hard deletes a Role
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteRole: (roleUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'roleUuid' is not null or undefined
            (0, common_1.assertParamExists)('hardDeleteRole', 'roleUuid', roleUuid);
            const localVarPath = `/admin/roles/{roleUuid}`
                .replace(`{${"roleUuid"}}`, encodeURIComponent(String(roleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes:       auth-audit-delete,       auth-role-scope-delete,       auth-hard-delete
         * @summary Hard deletes a role\'s scope
         * @param {string} roleScopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteRoleScope: (roleScopeUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'roleScopeUuid' is not null or undefined
            (0, common_1.assertParamExists)('hardDeleteRoleScope', 'roleScopeUuid', roleScopeUuid);
            const localVarPath = `/admin/role-scopes/{roleScopeUuid}`
                .replace(`{${"roleScopeUuid"}}`, encodeURIComponent(String(roleScopeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes:       auth-audit-delete,       auth-scope-delete,       auth-hard-delete
         * @summary Hard deletes a scope
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteScope: (scopeUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'scopeUuid' is not null or undefined
            (0, common_1.assertParamExists)('hardDeleteScope', 'scopeUuid', scopeUuid);
            const localVarPath = `/admin/scopes/{scopeUuid}`
                .replace(`{${"scopeUuid"}}`, encodeURIComponent(String(scopeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes:       auth-audit-delete,       auth-user-delete,       auth-hard-delete
         * @summary Hard deletes a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteUser: (userUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('hardDeleteUser', 'userUuid', userUuid);
            const localVarPath = `/admin/users/{userUuid}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes:       auth-audit-delete,       auth-user-role-delete,       auth-hard-delete
         * @summary Hard deletes a user\'s role
         * @param {string} userRoleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteUserRole: (userRoleUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userRoleUuid' is not null or undefined
            (0, common_1.assertParamExists)('hardDeleteUserRole', 'userRoleUuid', userRoleUuid);
            const localVarPath = `/admin/user-roles/{userRoleUuid}`
                .replace(`{${"userRoleUuid"}}`, encodeURIComponent(String(userRoleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        livenessCheck: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Logs the user into Pear system
         * @param {LoginDTO} loginDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: (loginDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'loginDTO' is not null or undefined
            (0, common_1.assertParamExists)('login', 'loginDTO', loginDTO);
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidates the provided auth token in Auth service, Papi, or Sapi
         * @summary Log the user out
         * @param {LogoutRequestDto} logoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: (logoutRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'logoutRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('logout', 'logoutRequestDto', logoutRequestDto);
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(logoutRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * No scope requirements
         * @summary Deletes a target user\'s MFA setting
         * @param {DeleteUserMfaRequestDTO} deleteUserMfaRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserMfa: (deleteUserMfaRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'deleteUserMfaRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('removeUserMfa', 'deleteUserMfaRequestDTO', deleteUserMfaRequestDTO);
            const localVarPath = `/login/mfa/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteUserMfaRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Requests password reset
         * @param {RequestPasswordResetDTO} requestPasswordResetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: (requestPasswordResetDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestPasswordResetDTO' is not null or undefined
            (0, common_1.assertParamExists)('requestPasswordReset', 'requestPasswordResetDTO', requestPasswordResetDTO);
            const localVarPath = `/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPasswordResetDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-password-reset-token-create
         * @summary Request a password reset token for a user
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordResetTokenForUser: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('requestPasswordResetTokenForUser', 'uuid', uuid);
            const localVarPath = `/users/{uuid}/password`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-update
         * @summary Add an address to an existing group
         * @param {string} groupUuid
         * @param {AddressPutDto} addressPutDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupAddress: (groupUuid, addressPutDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('setGroupAddress', 'groupUuid', groupUuid);
            // verify required parameter 'addressPutDto' is not null or undefined
            (0, common_1.assertParamExists)('setGroupAddress', 'addressPutDto', addressPutDto);
            const localVarPath = `/groups/{groupUuid}/address`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addressPutDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-external-ref-set
         * @summary Create or update an external ref associated with this group.
         * @param {string} groupUuid
         * @param {string} type
         * @param {ExternalRefSetDto} externalRefSetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupExternalRef: (groupUuid, type, externalRefSetDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('setGroupExternalRef', 'groupUuid', groupUuid);
            // verify required parameter 'type' is not null or undefined
            (0, common_1.assertParamExists)('setGroupExternalRef', 'type', type);
            // verify required parameter 'externalRefSetDto' is not null or undefined
            (0, common_1.assertParamExists)('setGroupExternalRef', 'externalRefSetDto', externalRefSetDto);
            const localVarPath = `/groups/{groupUuid}/external/{type}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(externalRefSetDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-user-external-ref-set
         * @summary Creates or updates an ExternalRef for a user
         * @param {string} userUuid
         * @param {string} type
         * @param {ExternalRefSetDto} externalRefSetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserExternalRef: (userUuid, type, externalRefSetDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userUuid' is not null or undefined
            (0, common_1.assertParamExists)('setUserExternalRef', 'userUuid', userUuid);
            // verify required parameter 'type' is not null or undefined
            (0, common_1.assertParamExists)('setUserExternalRef', 'type', type);
            // verify required parameter 'externalRefSetDto' is not null or undefined
            (0, common_1.assertParamExists)('setUserExternalRef', 'externalRefSetDto', externalRefSetDto);
            const localVarPath = `/users/{userUuid}/external/{type}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(externalRefSetDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Protected endpoint without any scope definition
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAuth: (authorization, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'authorization' is not null or undefined
            (0, common_1.assertParamExists)('testAuth', 'authorization', authorization);
            const localVarPath = `/sla-test/test-auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: non-existing-scope
         * @summary Protected endpoint with scopes definition that should not exist in any system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testFakeScopes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sla-test/test-fake-scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-role-read
         * @summary Protected endpoint with scopes definition; Should get jwt token back
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testScopes: (authorization, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'authorization' is not null or undefined
            (0, common_1.assertParamExists)('testScopes', 'authorization', authorization);
            const localVarPath = `/sla-test/test-admin-user-scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unAuth: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sla-test/unauth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-group-update
         * @summary Update an existing group
         * @param {string} groupUuid
         * @param {GroupUpdateDto} groupUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: (groupUuid, groupUpdateDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupUuid' is not null or undefined
            (0, common_1.assertParamExists)('updateGroup', 'groupUuid', groupUuid);
            // verify required parameter 'groupUpdateDto' is not null or undefined
            (0, common_1.assertParamExists)('updateGroup', 'groupUpdateDto', groupUpdateDto);
            const localVarPath = `/groups/{groupUuid}`
                .replace(`{${"groupUuid"}}`, encodeURIComponent(String(groupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(groupUpdateDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Updates password
         * @param {UpdatePasswordDTO} updatePasswordDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: (updatePasswordDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updatePasswordDTO' is not null or undefined
            (0, common_1.assertParamExists)('updatePassword', 'updatePasswordDTO', updatePasswordDTO);
            const localVarPath = `/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePasswordDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-role-update
         * @summary Updates a role
         * @param {string} uuid
         * @param {RoleCreateOrUpdateDTO} roleCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: (uuid, roleCreateOrUpdateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('updateRole', 'uuid', uuid);
            // verify required parameter 'roleCreateOrUpdateDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateRole', 'roleCreateOrUpdateDTO', roleCreateOrUpdateDTO);
            const localVarPath = `/roles/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roleCreateOrUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-role-scope-create, auth-role-scope-delete
         * @summary Updates roles for a scope
         * @param {string} uuid
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRolesForScope: (uuid, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('updateRolesForScope', 'uuid', uuid);
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('updateRolesForScope', 'requestBody', requestBody);
            const localVarPath = `/scopes/{uuid}/roles`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-scope-update
         * @summary Updates a scope
         * @param {string} uuid
         * @param {ScopeCreateOrUpdateDTO} scopeCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScope: (uuid, scopeCreateOrUpdateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('updateScope', 'uuid', uuid);
            // verify required parameter 'scopeCreateOrUpdateDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateScope', 'scopeCreateOrUpdateDTO', scopeCreateOrUpdateDTO);
            const localVarPath = `/scopes/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scopeCreateOrUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scopes: auth-role-scope-delete, auth-role-scope-create
         * @summary Updates scopes for a role
         * @param {string} uuid
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScopesForRole: (uuid, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('updateScopesForRole', 'uuid', uuid);
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('updateScopesForRole', 'requestBody', requestBody);
            const localVarPath = `/roles/{uuid}/scopes`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Required scope: auth-user-update
         * @summary Updates a user
         * @param {string} uuid
         * @param {UserCreateOrUpdateDTO} userCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: (uuid, userCreateOrUpdateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            (0, common_1.assertParamExists)('updateUser', 'uuid', uuid);
            // verify required parameter 'userCreateOrUpdateDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateUser', 'userCreateOrUpdateDTO', userCreateOrUpdateDTO);
            const localVarPath = `/users/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication UserContextJWT required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "user_context", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userCreateOrUpdateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Validate an auth token and return the user ID to which the token belongs
         * @param {TokenValidationRequestDto} tokenValidationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAuthToken: (tokenValidationRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tokenValidationRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('validateAuthToken', 'tokenValidationRequestDto', tokenValidationRequestDto);
            const localVarPath = `/login/auth-token/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tokenValidationRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * No scope requirements
         * @summary Verifies user MFA token, registers users device, and returns auth token
         * @param {VerifyMfaTokenRequestDTO} verifyMfaTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMfaPasscodeAndRegisterDevice: (verifyMfaTokenRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'verifyMfaTokenRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('validateMfaPasscodeAndRegisterDevice', 'verifyMfaTokenRequestDTO', verifyMfaTokenRequestDTO);
            const localVarPath = `/login/mfa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyMfaTokenRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * No scope requirements
         * @summary Validates user MFA passcode and returns auth token
         * @param {VerifyMfaTokenRequestDTO} verifyMfaTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMfaToken: (verifyMfaTokenRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'verifyMfaTokenRequestDTO' is not null or undefined
            (0, common_1.assertParamExists)('validateMfaToken', 'verifyMfaTokenRequestDTO', verifyMfaTokenRequestDTO);
            const localVarPath = `/login/mfa/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyMfaTokenRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         * Required scope: auth-user-role-create
         * @summary Adds roles to a user
         * @param {string} userUuid
         * @param {UserRoleCreateDTO} userRoleCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleForUser(userUuid, userRoleCreateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addRoleForUser(userUuid, userRoleCreateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-user-create
         * @summary Assign a user to a group
         * @param {string} groupUuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUserToGroup(groupUuid, userUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assignUserToGroup(groupUuid, userUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-role-scope-create
         * @summary Associates a scope to a role
         * @param {string} uuid
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateRoleToScope(uuid, scopeUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.associateRoleToScope(uuid, scopeUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-role-scope-create
         * @summary Associates a role to a scope
         * @param {string} uuid
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateScopeToRole(uuid, roleUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.associateScopeToRole(uuid, roleUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-role-create
         * @summary Bulk creates roles
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateRoles(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bulkCreateRoles(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-scope-create
         * @summary Bulk creates scopes
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateScopes(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bulkCreateScopes(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Consumes an existing verification token, authenticating the User to whom it was associated
         * @param {VerificationTokenConsumeRequestDTO} verificationTokenConsumeRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeVerificationToken(verificationTokenConsumeRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.consumeVerificationToken(verificationTokenConsumeRequestDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-group-create
         * @summary Creates a group
         * @param {GroupCreateDto} groupCreateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(groupCreateDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createGroup(groupCreateDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-profile-create, auth-profile-update
         * @summary Creates or updates a profile for a user
         * @param {string} userUuid
         * @param {ProfileCreateOrUpdateDTO} profileCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateUserProfile(userUuid, profileCreateOrUpdateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOrUpdateUserProfile(userUuid, profileCreateOrUpdateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-role-create
         * @summary Creates a role
         * @param {RoleCreateOrUpdateDTO} roleCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(roleCreateOrUpdateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createRole(roleCreateOrUpdateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-scope-create
         * @summary Creates a new scope
         * @param {ScopeCreateOrUpdateDTO} scopeCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScope(scopeCreateOrUpdateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createScope(scopeCreateOrUpdateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-create
         * @summary Creates a new user
         * @param {UserCreateOrUpdateDTO} userCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreateOrUpdateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUser(userCreateOrUpdateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-create
         * @summary Bulk creates users
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsers(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUsers(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-delete
         * @summary Delete a group
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(groupUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteGroup(groupUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-external-ref-delete
         * @summary Delete an external ref associated with this group.
         * @param {string} groupUuid
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupExternalRef(groupUuid, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteGroupExternalRef(groupUuid, type, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-role-delete
         * @summary Deletes a role
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteRole(uuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-role-delete
         * @summary Deletes a role from a user
         * @param {string} userUuid
         * @param {string} userRoleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleForUser(userUuid, userRoleUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteRoleForUser(userUuid, userRoleUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-role-scope-delete
         * @summary Deletes a scope\'s association to a role
         * @param {string} uuid
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleToScopeAssociation(uuid, scopeUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteRoleToScopeAssociation(uuid, scopeUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-scope-delete
         * @summary Deletes a scope
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScope(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteScope(uuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-role-scope-delete
         * @summary Deletes an association between a role and a scope
         * @param {string} uuid
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScopeToRoleAssociation(uuid, roleUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteScopeToRoleAssociation(uuid, roleUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-delete
         * @summary Deletes a user
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUser(uuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-user-delete
         * @summary Deletion of a user from a group
         * @param {string} groupUuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserFromGroup(groupUuid, userUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserFromGroup(groupUuid, userUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-profile-delete
         * @summary Deletes a profile for a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserProfile(userUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserProfile(userUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnosisCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.diagnosisCheck(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-user-external-ref-read.
         * @summary Get a user by external ref type and external ref id
         * @param {string} externalType
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserByExternalRef(externalType, externalId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findUserByExternalRef(externalType, externalId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-search Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Search for users by user or profile info
         * @param {UserFindDTO} userFindDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsers(userFindDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findUsers(userFindDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * No scope requirements
         * @summary Generates a QR code that can be used to setup/enable MFA
         * @param {GenerateMfaTokenRequestDto} generateMfaTokenRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMfaToken(generateMfaTokenRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateMfaToken(generateMfaTokenRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Requests token generation
         * @param {VerificationTokenGenerateRequestDTO} verificationTokenGenerateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVerificationToken(verificationTokenGenerateRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateVerificationToken(verificationTokenGenerateRequestDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-role-read
         * @summary Get all roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllRoles(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-scope-read
         * @summary Returns all scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScopes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllScopes(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the current user record, optionally including the profile and roles. This is needed for users to fetch their own info; The get-user-by-ID endpoint is not useful in this case since users do not yet know their IDs.
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentUser(include, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-read
         * @summary Get a group by ID
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(groupUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGroup(groupUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-user-list Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Returns a list of users for a group
         * @param {string} groupUuid
         * @param {number} page
         * @param {string} [username] Presence: optional
         * @param {string} [firstName] Presence: optional
         * @param {string} [lastName] Presence: optional
         * @param {string} [email] Presence: optional
         * @param {string} [roleName] Provide a Role Name which should be present for returned Principals.&lt;br&gt;Presence: optional
         * @param {Array<string>} [context] Indicate context properties which should be matched using key:value strings.
         * @param {boolean} [recursive] Indicate whether groups should be scanned recursively.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupUsers(groupUuid, page, username, firstName, lastName, email, roleName, context, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGroupUsers(groupUuid, page, username, firstName, lastName, email, roleName, context, recursive, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-list Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new groups added). This means that a record appearing at the end of a page might appear again on the following page, or a group at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Fetch the groups in the system, optionally filtering by name, category, or parent group ID
         * @param {number} [page] Presence: optional
         * @param {string} [name] Presence: optional
         * @param {string} [category] Presence: optional; nullable
         * @param {string} [parentUuid] Presence: optional; nullable
         * @param {string} [externalType] Presence: optional
         * @param {string} [externalId] Presence: optional
         * @param {boolean} [includeAddress] Presence: optional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(page, name, category, parentUuid, externalType, externalId, includeAddress, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGroups(page, name, category, parentUuid, externalType, externalId, includeAddress, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-role-read, auth-role-scope-read, auth-scope-read
         * @summary Gets a role
         * @param {string} uuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(uuid, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRole(uuid, include, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-role-scope-read, auth-role-read
         * @summary Gets roles for a scope
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForScope(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRolesForScope(uuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-user-role-read
         * @summary Gets roles for a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForUser(userUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRolesForUser(userUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-scope-read
         * @summary Returns a specific scope
         * @param {string} uuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScope(uuid, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getScope(uuid, include, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-role-scope-read, auth-scope-read
         * @summary Gets scopes for a role
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopesForRole(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getScopesForRole(uuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-user-read. Optional scopes: auth-user-role-read, auth-profile-read
         * @summary Get a user by ID
         * @param {string} userUuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userUuid, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserById(userUuid, include, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets user context for a token
         * @param {UserContextRequestDto} userContextRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContext(userContextRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserContext(userContextRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets user context for a PAPI/AUTH token
         * @param {UserContextRequestDto} userContextRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContextForCommercial(userContextRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserContextForCommercial(userContextRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets user context for a sapi token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContextForStudy(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserContextForStudy(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-group-list
         * @summary Fetch the groups to which the given user belongs
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroups(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserGroups(uuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-list-all Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Search for users by user or profile info
         * @param {number} [page] Presence: optional
         * @param {string} [username] Presence: optional
         * @param {string} [firstName] Presence: optional
         * @param {string} [lastName] Presence: optional
         * @param {string} [email] Presence: optional
         * @param {string} [mobilePhone] Presence: optional
         * @param {string} [birthDate] Presence: optional
         * @param {string} [papiId] Presence: optional
         * @param {string} [sapiId] Presence: optional
         * @param {string} [roleId] Presence: optional
         * @param {string} [groupUuid] Presence: optional
         * @param {boolean} [includeSubGroups] Presence: optional
         * @param {string} [roleName] Presence: optional
         * @param {'permissions' | 'profile'} [include] Presence: optional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(page, username, firstName, lastName, email, mobilePhone, birthDate, papiId, sapiId, roleId, groupUuid, includeSubGroups, roleName, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsers(page, username, firstName, lastName, email, mobilePhone, birthDate, papiId, sapiId, roleId, groupUuid, includeSubGroups, roleName, include, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-search. Max UUIDs: 20.
         * @summary Returns an array of users with the given UUIDs
         * @param {Array<string>} uuid A single UUID or an array of UUIDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersById(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsersById(uuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-group-delete,       auth-hard-delete
         * @summary Hard deletes a group
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteGroup(groupUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hardDeleteGroup(groupUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-role-delete,       auth-hard-delete
         * @summary Hard deletes a Role
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteRole(roleUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hardDeleteRole(roleUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-role-scope-delete,       auth-hard-delete
         * @summary Hard deletes a role\'s scope
         * @param {string} roleScopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteRoleScope(roleScopeUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hardDeleteRoleScope(roleScopeUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-scope-delete,       auth-hard-delete
         * @summary Hard deletes a scope
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteScope(scopeUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hardDeleteScope(scopeUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-user-delete,       auth-hard-delete
         * @summary Hard deletes a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteUser(userUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hardDeleteUser(userUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-user-role-delete,       auth-hard-delete
         * @summary Hard deletes a user\'s role
         * @param {string} userRoleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteUserRole(userRoleUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hardDeleteUserRole(userRoleUuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        livenessCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.livenessCheck(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Logs the user into Pear system
         * @param {LoginDTO} loginDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.login(loginDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Invalidates the provided auth token in Auth service, Papi, or Sapi
         * @summary Log the user out
         * @param {LogoutRequestDto} logoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(logoutRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logout(logoutRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * No scope requirements
         * @summary Deletes a target user\'s MFA setting
         * @param {DeleteUserMfaRequestDTO} deleteUserMfaRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserMfa(deleteUserMfaRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeUserMfa(deleteUserMfaRequestDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Requests password reset
         * @param {RequestPasswordResetDTO} requestPasswordResetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(requestPasswordResetDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestPasswordReset(requestPasswordResetDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-password-reset-token-create
         * @summary Request a password reset token for a user
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordResetTokenForUser(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestPasswordResetTokenForUser(uuid, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-update
         * @summary Add an address to an existing group
         * @param {string} groupUuid
         * @param {AddressPutDto} addressPutDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupAddress(groupUuid, addressPutDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setGroupAddress(groupUuid, addressPutDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-external-ref-set
         * @summary Create or update an external ref associated with this group.
         * @param {string} groupUuid
         * @param {string} type
         * @param {ExternalRefSetDto} externalRefSetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupExternalRef(groupUuid, type, externalRefSetDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setGroupExternalRef(groupUuid, type, externalRefSetDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-user-external-ref-set
         * @summary Creates or updates an ExternalRef for a user
         * @param {string} userUuid
         * @param {string} type
         * @param {ExternalRefSetDto} externalRefSetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserExternalRef(userUuid, type, externalRefSetDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setUserExternalRef(userUuid, type, externalRefSetDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Protected endpoint without any scope definition
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAuth(authorization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testAuth(authorization, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: non-existing-scope
         * @summary Protected endpoint with scopes definition that should not exist in any system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testFakeScopes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testFakeScopes(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-role-read
         * @summary Protected endpoint with scopes definition; Should get jwt token back
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testScopes(authorization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testScopes(authorization, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unAuth(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unAuth(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-group-update
         * @summary Update an existing group
         * @param {string} groupUuid
         * @param {GroupUpdateDto} groupUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(groupUuid, groupUpdateDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateGroup(groupUuid, groupUpdateDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Updates password
         * @param {UpdatePasswordDTO} updatePasswordDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(updatePasswordDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePassword(updatePasswordDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-role-update
         * @summary Updates a role
         * @param {string} uuid
         * @param {RoleCreateOrUpdateDTO} roleCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(uuid, roleCreateOrUpdateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateRole(uuid, roleCreateOrUpdateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-role-scope-create, auth-role-scope-delete
         * @summary Updates roles for a scope
         * @param {string} uuid
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRolesForScope(uuid, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateRolesForScope(uuid, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-scope-update
         * @summary Updates a scope
         * @param {string} uuid
         * @param {ScopeCreateOrUpdateDTO} scopeCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScope(uuid, scopeCreateOrUpdateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateScope(uuid, scopeCreateOrUpdateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scopes: auth-role-scope-delete, auth-role-scope-create
         * @summary Updates scopes for a role
         * @param {string} uuid
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScopesForRole(uuid, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateScopesForRole(uuid, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Required scope: auth-user-update
         * @summary Updates a user
         * @param {string} uuid
         * @param {UserCreateOrUpdateDTO} userCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(uuid, userCreateOrUpdateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUser(uuid, userCreateOrUpdateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Validate an auth token and return the user ID to which the token belongs
         * @param {TokenValidationRequestDto} tokenValidationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAuthToken(tokenValidationRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateAuthToken(tokenValidationRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * No scope requirements
         * @summary Verifies user MFA token, registers users device, and returns auth token
         * @param {VerifyMfaTokenRequestDTO} verifyMfaTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMfaPasscodeAndRegisterDevice(verifyMfaTokenRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateMfaPasscodeAndRegisterDevice(verifyMfaTokenRequestDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * No scope requirements
         * @summary Validates user MFA passcode and returns auth token
         * @param {VerifyMfaTokenRequestDTO} verifyMfaTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMfaToken(verifyMfaTokenRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateMfaToken(verifyMfaTokenRequestDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         * Required scope: auth-user-role-create
         * @summary Adds roles to a user
         * @param {string} userUuid
         * @param {UserRoleCreateDTO} userRoleCreateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleForUser(userUuid, userRoleCreateDTO, options) {
            return localVarFp.addRoleForUser(userUuid, userRoleCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-user-create
         * @summary Assign a user to a group
         * @param {string} groupUuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUserToGroup(groupUuid, userUuid, options) {
            return localVarFp.assignUserToGroup(groupUuid, userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-role-scope-create
         * @summary Associates a scope to a role
         * @param {string} uuid
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateRoleToScope(uuid, scopeUuid, options) {
            return localVarFp.associateRoleToScope(uuid, scopeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-role-scope-create
         * @summary Associates a role to a scope
         * @param {string} uuid
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateScopeToRole(uuid, roleUuid, options) {
            return localVarFp.associateScopeToRole(uuid, roleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-role-create
         * @summary Bulk creates roles
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateRoles(requestBody, options) {
            return localVarFp.bulkCreateRoles(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-scope-create
         * @summary Bulk creates scopes
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateScopes(requestBody, options) {
            return localVarFp.bulkCreateScopes(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Consumes an existing verification token, authenticating the User to whom it was associated
         * @param {VerificationTokenConsumeRequestDTO} verificationTokenConsumeRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeVerificationToken(verificationTokenConsumeRequestDTO, options) {
            return localVarFp.consumeVerificationToken(verificationTokenConsumeRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-group-create
         * @summary Creates a group
         * @param {GroupCreateDto} groupCreateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(groupCreateDto, options) {
            return localVarFp.createGroup(groupCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-profile-create, auth-profile-update
         * @summary Creates or updates a profile for a user
         * @param {string} userUuid
         * @param {ProfileCreateOrUpdateDTO} profileCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateUserProfile(userUuid, profileCreateOrUpdateDTO, options) {
            return localVarFp.createOrUpdateUserProfile(userUuid, profileCreateOrUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-role-create
         * @summary Creates a role
         * @param {RoleCreateOrUpdateDTO} roleCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(roleCreateOrUpdateDTO, options) {
            return localVarFp.createRole(roleCreateOrUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-scope-create
         * @summary Creates a new scope
         * @param {ScopeCreateOrUpdateDTO} scopeCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScope(scopeCreateOrUpdateDTO, options) {
            return localVarFp.createScope(scopeCreateOrUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-create
         * @summary Creates a new user
         * @param {UserCreateOrUpdateDTO} userCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userCreateOrUpdateDTO, options) {
            return localVarFp.createUser(userCreateOrUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-create
         * @summary Bulk creates users
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsers(requestBody, options) {
            return localVarFp.createUsers(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-delete
         * @summary Delete a group
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(groupUuid, options) {
            return localVarFp.deleteGroup(groupUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-external-ref-delete
         * @summary Delete an external ref associated with this group.
         * @param {string} groupUuid
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupExternalRef(groupUuid, type, options) {
            return localVarFp.deleteGroupExternalRef(groupUuid, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-role-delete
         * @summary Deletes a role
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(uuid, options) {
            return localVarFp.deleteRole(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-role-delete
         * @summary Deletes a role from a user
         * @param {string} userUuid
         * @param {string} userRoleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleForUser(userUuid, userRoleUuid, options) {
            return localVarFp.deleteRoleForUser(userUuid, userRoleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-role-scope-delete
         * @summary Deletes a scope\'s association to a role
         * @param {string} uuid
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleToScopeAssociation(uuid, scopeUuid, options) {
            return localVarFp.deleteRoleToScopeAssociation(uuid, scopeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-scope-delete
         * @summary Deletes a scope
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScope(uuid, options) {
            return localVarFp.deleteScope(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-role-scope-delete
         * @summary Deletes an association between a role and a scope
         * @param {string} uuid
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScopeToRoleAssociation(uuid, roleUuid, options) {
            return localVarFp.deleteScopeToRoleAssociation(uuid, roleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-delete
         * @summary Deletes a user
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(uuid, options) {
            return localVarFp.deleteUser(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-user-delete
         * @summary Deletion of a user from a group
         * @param {string} groupUuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserFromGroup(groupUuid, userUuid, options) {
            return localVarFp.deleteUserFromGroup(groupUuid, userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-profile-delete
         * @summary Deletes a profile for a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserProfile(userUuid, options) {
            return localVarFp.deleteUserProfile(userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        diagnosisCheck(options) {
            return localVarFp.diagnosisCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-user-external-ref-read.
         * @summary Get a user by external ref type and external ref id
         * @param {string} externalType
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserByExternalRef(externalType, externalId, options) {
            return localVarFp.findUserByExternalRef(externalType, externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-search Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Search for users by user or profile info
         * @param {UserFindDTO} userFindDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsers(userFindDTO, options) {
            return localVarFp.findUsers(userFindDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * No scope requirements
         * @summary Generates a QR code that can be used to setup/enable MFA
         * @param {GenerateMfaTokenRequestDto} generateMfaTokenRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMfaToken(generateMfaTokenRequestDto, options) {
            return localVarFp.generateMfaToken(generateMfaTokenRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Requests token generation
         * @param {VerificationTokenGenerateRequestDTO} verificationTokenGenerateRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVerificationToken(verificationTokenGenerateRequestDTO, options) {
            return localVarFp.generateVerificationToken(verificationTokenGenerateRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-role-read
         * @summary Get all roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles(options) {
            return localVarFp.getAllRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-scope-read
         * @summary Returns all scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllScopes(options) {
            return localVarFp.getAllScopes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current user record, optionally including the profile and roles. This is needed for users to fetch their own info; The get-user-by-ID endpoint is not useful in this case since users do not yet know their IDs.
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(include, options) {
            return localVarFp.getCurrentUser(include, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-read
         * @summary Get a group by ID
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(groupUuid, options) {
            return localVarFp.getGroup(groupUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-user-list Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Returns a list of users for a group
         * @param {string} groupUuid
         * @param {number} page
         * @param {string} [username] Presence: optional
         * @param {string} [firstName] Presence: optional
         * @param {string} [lastName] Presence: optional
         * @param {string} [email] Presence: optional
         * @param {string} [roleName] Provide a Role Name which should be present for returned Principals.&lt;br&gt;Presence: optional
         * @param {Array<string>} [context] Indicate context properties which should be matched using key:value strings.
         * @param {boolean} [recursive] Indicate whether groups should be scanned recursively.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupUsers(groupUuid, page, username, firstName, lastName, email, roleName, context, recursive, options) {
            return localVarFp.getGroupUsers(groupUuid, page, username, firstName, lastName, email, roleName, context, recursive, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-list Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new groups added). This means that a record appearing at the end of a page might appear again on the following page, or a group at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Fetch the groups in the system, optionally filtering by name, category, or parent group ID
         * @param {number} [page] Presence: optional
         * @param {string} [name] Presence: optional
         * @param {string} [category] Presence: optional; nullable
         * @param {string} [parentUuid] Presence: optional; nullable
         * @param {string} [externalType] Presence: optional
         * @param {string} [externalId] Presence: optional
         * @param {boolean} [includeAddress] Presence: optional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(page, name, category, parentUuid, externalType, externalId, includeAddress, options) {
            return localVarFp.getGroups(page, name, category, parentUuid, externalType, externalId, includeAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-role-read, auth-role-scope-read, auth-scope-read
         * @summary Gets a role
         * @param {string} uuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(uuid, include, options) {
            return localVarFp.getRole(uuid, include, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-role-scope-read, auth-role-read
         * @summary Gets roles for a scope
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForScope(uuid, options) {
            return localVarFp.getRolesForScope(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-user-role-read
         * @summary Gets roles for a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForUser(userUuid, options) {
            return localVarFp.getRolesForUser(userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-scope-read
         * @summary Returns a specific scope
         * @param {string} uuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScope(uuid, include, options) {
            return localVarFp.getScope(uuid, include, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-role-scope-read, auth-scope-read
         * @summary Gets scopes for a role
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopesForRole(uuid, options) {
            return localVarFp.getScopesForRole(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-user-read. Optional scopes: auth-user-role-read, auth-profile-read
         * @summary Get a user by ID
         * @param {string} userUuid
         * @param {string} include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userUuid, include, options) {
            return localVarFp.getUserById(userUuid, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets user context for a token
         * @param {UserContextRequestDto} userContextRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContext(userContextRequestDto, options) {
            return localVarFp.getUserContext(userContextRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets user context for a PAPI/AUTH token
         * @param {UserContextRequestDto} userContextRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContextForCommercial(userContextRequestDto, options) {
            return localVarFp.getUserContextForCommercial(userContextRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets user context for a sapi token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContextForStudy(options) {
            return localVarFp.getUserContextForStudy(options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-group-list
         * @summary Fetch the groups to which the given user belongs
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroups(uuid, options) {
            return localVarFp.getUserGroups(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-list-all Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
         * @summary Search for users by user or profile info
         * @param {number} [page] Presence: optional
         * @param {string} [username] Presence: optional
         * @param {string} [firstName] Presence: optional
         * @param {string} [lastName] Presence: optional
         * @param {string} [email] Presence: optional
         * @param {string} [mobilePhone] Presence: optional
         * @param {string} [birthDate] Presence: optional
         * @param {string} [papiId] Presence: optional
         * @param {string} [sapiId] Presence: optional
         * @param {string} [roleId] Presence: optional
         * @param {string} [groupUuid] Presence: optional
         * @param {boolean} [includeSubGroups] Presence: optional
         * @param {string} [roleName] Presence: optional
         * @param {'permissions' | 'profile'} [include] Presence: optional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(page, username, firstName, lastName, email, mobilePhone, birthDate, papiId, sapiId, roleId, groupUuid, includeSubGroups, roleName, include, options) {
            return localVarFp.getUsers(page, username, firstName, lastName, email, mobilePhone, birthDate, papiId, sapiId, roleId, groupUuid, includeSubGroups, roleName, include, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-search. Max UUIDs: 20.
         * @summary Returns an array of users with the given UUIDs
         * @param {Array<string>} uuid A single UUID or an array of UUIDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersById(uuid, options) {
            return localVarFp.getUsersById(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-group-delete,       auth-hard-delete
         * @summary Hard deletes a group
         * @param {string} groupUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteGroup(groupUuid, options) {
            return localVarFp.hardDeleteGroup(groupUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-role-delete,       auth-hard-delete
         * @summary Hard deletes a Role
         * @param {string} roleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteRole(roleUuid, options) {
            return localVarFp.hardDeleteRole(roleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-role-scope-delete,       auth-hard-delete
         * @summary Hard deletes a role\'s scope
         * @param {string} roleScopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteRoleScope(roleScopeUuid, options) {
            return localVarFp.hardDeleteRoleScope(roleScopeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-scope-delete,       auth-hard-delete
         * @summary Hard deletes a scope
         * @param {string} scopeUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteScope(scopeUuid, options) {
            return localVarFp.hardDeleteScope(scopeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-user-delete,       auth-hard-delete
         * @summary Hard deletes a user
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteUser(userUuid, options) {
            return localVarFp.hardDeleteUser(userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes:       auth-audit-delete,       auth-user-role-delete,       auth-hard-delete
         * @summary Hard deletes a user\'s role
         * @param {string} userRoleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteUserRole(userRoleUuid, options) {
            return localVarFp.hardDeleteUserRole(userRoleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        livenessCheck(options) {
            return localVarFp.livenessCheck(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Logs the user into Pear system
         * @param {LoginDTO} loginDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDTO, options) {
            return localVarFp.login(loginDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidates the provided auth token in Auth service, Papi, or Sapi
         * @summary Log the user out
         * @param {LogoutRequestDto} logoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(logoutRequestDto, options) {
            return localVarFp.logout(logoutRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * No scope requirements
         * @summary Deletes a target user\'s MFA setting
         * @param {DeleteUserMfaRequestDTO} deleteUserMfaRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserMfa(deleteUserMfaRequestDTO, options) {
            return localVarFp.removeUserMfa(deleteUserMfaRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Requests password reset
         * @param {RequestPasswordResetDTO} requestPasswordResetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(requestPasswordResetDTO, options) {
            return localVarFp.requestPasswordReset(requestPasswordResetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-password-reset-token-create
         * @summary Request a password reset token for a user
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordResetTokenForUser(uuid, options) {
            return localVarFp.requestPasswordResetTokenForUser(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-update
         * @summary Add an address to an existing group
         * @param {string} groupUuid
         * @param {AddressPutDto} addressPutDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupAddress(groupUuid, addressPutDto, options) {
            return localVarFp.setGroupAddress(groupUuid, addressPutDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-external-ref-set
         * @summary Create or update an external ref associated with this group.
         * @param {string} groupUuid
         * @param {string} type
         * @param {ExternalRefSetDto} externalRefSetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupExternalRef(groupUuid, type, externalRefSetDto, options) {
            return localVarFp.setGroupExternalRef(groupUuid, type, externalRefSetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-user-external-ref-set
         * @summary Creates or updates an ExternalRef for a user
         * @param {string} userUuid
         * @param {string} type
         * @param {ExternalRefSetDto} externalRefSetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserExternalRef(userUuid, type, externalRefSetDto, options) {
            return localVarFp.setUserExternalRef(userUuid, type, externalRefSetDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Protected endpoint without any scope definition
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAuth(authorization, options) {
            return localVarFp.testAuth(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: non-existing-scope
         * @summary Protected endpoint with scopes definition that should not exist in any system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testFakeScopes(options) {
            return localVarFp.testFakeScopes(options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-role-read
         * @summary Protected endpoint with scopes definition; Should get jwt token back
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testScopes(authorization, options) {
            return localVarFp.testScopes(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unAuth(options) {
            return localVarFp.unAuth(options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-group-update
         * @summary Update an existing group
         * @param {string} groupUuid
         * @param {GroupUpdateDto} groupUpdateDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(groupUuid, groupUpdateDto, options) {
            return localVarFp.updateGroup(groupUuid, groupUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates password
         * @param {UpdatePasswordDTO} updatePasswordDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(updatePasswordDTO, options) {
            return localVarFp.updatePassword(updatePasswordDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-role-update
         * @summary Updates a role
         * @param {string} uuid
         * @param {RoleCreateOrUpdateDTO} roleCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(uuid, roleCreateOrUpdateDTO, options) {
            return localVarFp.updateRole(uuid, roleCreateOrUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-role-scope-create, auth-role-scope-delete
         * @summary Updates roles for a scope
         * @param {string} uuid
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRolesForScope(uuid, requestBody, options) {
            return localVarFp.updateRolesForScope(uuid, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-scope-update
         * @summary Updates a scope
         * @param {string} uuid
         * @param {ScopeCreateOrUpdateDTO} scopeCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScope(uuid, scopeCreateOrUpdateDTO, options) {
            return localVarFp.updateScope(uuid, scopeCreateOrUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scopes: auth-role-scope-delete, auth-role-scope-create
         * @summary Updates scopes for a role
         * @param {string} uuid
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScopesForRole(uuid, requestBody, options) {
            return localVarFp.updateScopesForRole(uuid, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Required scope: auth-user-update
         * @summary Updates a user
         * @param {string} uuid
         * @param {UserCreateOrUpdateDTO} userCreateOrUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(uuid, userCreateOrUpdateDTO, options) {
            return localVarFp.updateUser(uuid, userCreateOrUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Validate an auth token and return the user ID to which the token belongs
         * @param {TokenValidationRequestDto} tokenValidationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAuthToken(tokenValidationRequestDto, options) {
            return localVarFp.validateAuthToken(tokenValidationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * No scope requirements
         * @summary Verifies user MFA token, registers users device, and returns auth token
         * @param {VerifyMfaTokenRequestDTO} verifyMfaTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMfaPasscodeAndRegisterDevice(verifyMfaTokenRequestDTO, options) {
            return localVarFp.validateMfaPasscodeAndRegisterDevice(verifyMfaTokenRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * No scope requirements
         * @summary Validates user MFA passcode and returns auth token
         * @param {VerifyMfaTokenRequestDTO} verifyMfaTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMfaToken(verifyMfaTokenRequestDTO, options) {
            return localVarFp.validateMfaToken(verifyMfaTokenRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     * Required scope: auth-user-role-create
     * @summary Adds roles to a user
     * @param {DefaultApiAddRoleForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    addRoleForUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).addRoleForUser(requestParameters.userUuid, requestParameters.userRoleCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-user-create
     * @summary Assign a user to a group
     * @param {DefaultApiAssignUserToGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    assignUserToGroup(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).assignUserToGroup(requestParameters.groupUuid, requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-role-scope-create
     * @summary Associates a scope to a role
     * @param {DefaultApiAssociateRoleToScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    associateRoleToScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).associateRoleToScope(requestParameters.uuid, requestParameters.scopeUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-role-scope-create
     * @summary Associates a role to a scope
     * @param {DefaultApiAssociateScopeToRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    associateScopeToRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).associateScopeToRole(requestParameters.uuid, requestParameters.roleUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-role-create
     * @summary Bulk creates roles
     * @param {DefaultApiBulkCreateRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    bulkCreateRoles(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).bulkCreateRoles(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-scope-create
     * @summary Bulk creates scopes
     * @param {DefaultApiBulkCreateScopesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    bulkCreateScopes(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).bulkCreateScopes(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Consumes an existing verification token, authenticating the User to whom it was associated
     * @param {DefaultApiConsumeVerificationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    consumeVerificationToken(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).consumeVerificationToken(requestParameters.verificationTokenConsumeRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-group-create
     * @summary Creates a group
     * @param {DefaultApiCreateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createGroup(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createGroup(requestParameters.groupCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-profile-create, auth-profile-update
     * @summary Creates or updates a profile for a user
     * @param {DefaultApiCreateOrUpdateUserProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createOrUpdateUserProfile(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createOrUpdateUserProfile(requestParameters.userUuid, requestParameters.profileCreateOrUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-role-create
     * @summary Creates a role
     * @param {DefaultApiCreateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createRole(requestParameters.roleCreateOrUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-scope-create
     * @summary Creates a new scope
     * @param {DefaultApiCreateScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createScope(requestParameters.scopeCreateOrUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-create
     * @summary Creates a new user
     * @param {DefaultApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createUser(requestParameters.userCreateOrUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-create
     * @summary Bulk creates users
     * @param {DefaultApiCreateUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createUsers(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createUsers(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-delete
     * @summary Delete a group
     * @param {DefaultApiDeleteGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteGroup(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteGroup(requestParameters.groupUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-external-ref-delete
     * @summary Delete an external ref associated with this group.
     * @param {DefaultApiDeleteGroupExternalRefRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteGroupExternalRef(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteGroupExternalRef(requestParameters.groupUuid, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-role-delete
     * @summary Deletes a role
     * @param {DefaultApiDeleteRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteRole(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-role-delete
     * @summary Deletes a role from a user
     * @param {DefaultApiDeleteRoleForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteRoleForUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteRoleForUser(requestParameters.userUuid, requestParameters.userRoleUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-role-scope-delete
     * @summary Deletes a scope\'s association to a role
     * @param {DefaultApiDeleteRoleToScopeAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteRoleToScopeAssociation(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteRoleToScopeAssociation(requestParameters.uuid, requestParameters.scopeUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-scope-delete
     * @summary Deletes a scope
     * @param {DefaultApiDeleteScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteScope(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-role-scope-delete
     * @summary Deletes an association between a role and a scope
     * @param {DefaultApiDeleteScopeToRoleAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteScopeToRoleAssociation(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteScopeToRoleAssociation(requestParameters.uuid, requestParameters.roleUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-delete
     * @summary Deletes a user
     * @param {DefaultApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteUser(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-user-delete
     * @summary Deletion of a user from a group
     * @param {DefaultApiDeleteUserFromGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteUserFromGroup(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteUserFromGroup(requestParameters.groupUuid, requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-profile-delete
     * @summary Deletes a profile for a user
     * @param {DefaultApiDeleteUserProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteUserProfile(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteUserProfile(requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    diagnosisCheck(options) {
        return (0, exports.DefaultApiFp)(this.configuration).diagnosisCheck(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-user-external-ref-read.
     * @summary Get a user by external ref type and external ref id
     * @param {DefaultApiFindUserByExternalRefRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    findUserByExternalRef(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).findUserByExternalRef(requestParameters.externalType, requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-search Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
     * @summary Search for users by user or profile info
     * @param {DefaultApiFindUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    findUsers(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).findUsers(requestParameters.userFindDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * No scope requirements
     * @summary Generates a QR code that can be used to setup/enable MFA
     * @param {DefaultApiGenerateMfaTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    generateMfaToken(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).generateMfaToken(requestParameters.generateMfaTokenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Requests token generation
     * @param {DefaultApiGenerateVerificationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    generateVerificationToken(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).generateVerificationToken(requestParameters.verificationTokenGenerateRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-role-read
     * @summary Get all roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAllRoles(options) {
        return (0, exports.DefaultApiFp)(this.configuration).getAllRoles(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-scope-read
     * @summary Returns all scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAllScopes(options) {
        return (0, exports.DefaultApiFp)(this.configuration).getAllScopes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the current user record, optionally including the profile and roles. This is needed for users to fetch their own info; The get-user-by-ID endpoint is not useful in this case since users do not yet know their IDs.
     * @param {DefaultApiGetCurrentUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCurrentUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCurrentUser(requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-read
     * @summary Get a group by ID
     * @param {DefaultApiGetGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getGroup(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getGroup(requestParameters.groupUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-user-list Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
     * @summary Returns a list of users for a group
     * @param {DefaultApiGetGroupUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getGroupUsers(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getGroupUsers(requestParameters.groupUuid, requestParameters.page, requestParameters.username, requestParameters.firstName, requestParameters.lastName, requestParameters.email, requestParameters.roleName, requestParameters.context, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-list Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new groups added). This means that a record appearing at the end of a page might appear again on the following page, or a group at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
     * @summary Fetch the groups in the system, optionally filtering by name, category, or parent group ID
     * @param {DefaultApiGetGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getGroups(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getGroups(requestParameters.page, requestParameters.name, requestParameters.category, requestParameters.parentUuid, requestParameters.externalType, requestParameters.externalId, requestParameters.includeAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-role-read, auth-role-scope-read, auth-scope-read
     * @summary Gets a role
     * @param {DefaultApiGetRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getRole(requestParameters.uuid, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-role-scope-read, auth-role-read
     * @summary Gets roles for a scope
     * @param {DefaultApiGetRolesForScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getRolesForScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getRolesForScope(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-user-role-read
     * @summary Gets roles for a user
     * @param {DefaultApiGetRolesForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getRolesForUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getRolesForUser(requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-scope-read
     * @summary Returns a specific scope
     * @param {DefaultApiGetScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getScope(requestParameters.uuid, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-role-scope-read, auth-scope-read
     * @summary Gets scopes for a role
     * @param {DefaultApiGetScopesForRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getScopesForRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getScopesForRole(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-user-read. Optional scopes: auth-user-role-read, auth-profile-read
     * @summary Get a user by ID
     * @param {DefaultApiGetUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getUserById(requestParameters.userUuid, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets user context for a token
     * @param {DefaultApiGetUserContextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserContext(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getUserContext(requestParameters.userContextRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets user context for a PAPI/AUTH token
     * @param {DefaultApiGetUserContextForCommercialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserContextForCommercial(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getUserContextForCommercial(requestParameters.userContextRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets user context for a sapi token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserContextForStudy(options) {
        return (0, exports.DefaultApiFp)(this.configuration).getUserContextForStudy(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-group-list
     * @summary Fetch the groups to which the given user belongs
     * @param {DefaultApiGetUserGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserGroups(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getUserGroups(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-list-all Note: this endpoint returns offset based paginated results, which means the data might shift while we flip through the pages (for example: new users added). This means that a record appearing at the end of a page might appear again on the following page, or a user at the beginning of the next page might not show up when we filp to that page because in that time it would have shifted into the page that we flipped away from, in which case the user would need to flip back to that page to see the record.
     * @summary Search for users by user or profile info
     * @param {DefaultApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUsers(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getUsers(requestParameters.page, requestParameters.username, requestParameters.firstName, requestParameters.lastName, requestParameters.email, requestParameters.mobilePhone, requestParameters.birthDate, requestParameters.papiId, requestParameters.sapiId, requestParameters.roleId, requestParameters.groupUuid, requestParameters.includeSubGroups, requestParameters.roleName, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-search. Max UUIDs: 20.
     * @summary Returns an array of users with the given UUIDs
     * @param {DefaultApiGetUsersByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUsersById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getUsersById(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes:       auth-audit-delete,       auth-group-delete,       auth-hard-delete
     * @summary Hard deletes a group
     * @param {DefaultApiHardDeleteGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    hardDeleteGroup(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).hardDeleteGroup(requestParameters.groupUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes:       auth-audit-delete,       auth-role-delete,       auth-hard-delete
     * @summary Hard deletes a Role
     * @param {DefaultApiHardDeleteRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    hardDeleteRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).hardDeleteRole(requestParameters.roleUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes:       auth-audit-delete,       auth-role-scope-delete,       auth-hard-delete
     * @summary Hard deletes a role\'s scope
     * @param {DefaultApiHardDeleteRoleScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    hardDeleteRoleScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).hardDeleteRoleScope(requestParameters.roleScopeUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes:       auth-audit-delete,       auth-scope-delete,       auth-hard-delete
     * @summary Hard deletes a scope
     * @param {DefaultApiHardDeleteScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    hardDeleteScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).hardDeleteScope(requestParameters.scopeUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes:       auth-audit-delete,       auth-user-delete,       auth-hard-delete
     * @summary Hard deletes a user
     * @param {DefaultApiHardDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    hardDeleteUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).hardDeleteUser(requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes:       auth-audit-delete,       auth-user-role-delete,       auth-hard-delete
     * @summary Hard deletes a user\'s role
     * @param {DefaultApiHardDeleteUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    hardDeleteUserRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).hardDeleteUserRole(requestParameters.userRoleUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    livenessCheck(options) {
        return (0, exports.DefaultApiFp)(this.configuration).livenessCheck(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Logs the user into Pear system
     * @param {DefaultApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    login(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).login(requestParameters.loginDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invalidates the provided auth token in Auth service, Papi, or Sapi
     * @summary Log the user out
     * @param {DefaultApiLogoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    logout(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).logout(requestParameters.logoutRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * No scope requirements
     * @summary Deletes a target user\'s MFA setting
     * @param {DefaultApiRemoveUserMfaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    removeUserMfa(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).removeUserMfa(requestParameters.deleteUserMfaRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Requests password reset
     * @param {DefaultApiRequestPasswordResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    requestPasswordReset(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).requestPasswordReset(requestParameters.requestPasswordResetDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-password-reset-token-create
     * @summary Request a password reset token for a user
     * @param {DefaultApiRequestPasswordResetTokenForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    requestPasswordResetTokenForUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).requestPasswordResetTokenForUser(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-update
     * @summary Add an address to an existing group
     * @param {DefaultApiSetGroupAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    setGroupAddress(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).setGroupAddress(requestParameters.groupUuid, requestParameters.addressPutDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-external-ref-set
     * @summary Create or update an external ref associated with this group.
     * @param {DefaultApiSetGroupExternalRefRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    setGroupExternalRef(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).setGroupExternalRef(requestParameters.groupUuid, requestParameters.type, requestParameters.externalRefSetDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-user-external-ref-set
     * @summary Creates or updates an ExternalRef for a user
     * @param {DefaultApiSetUserExternalRefRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    setUserExternalRef(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).setUserExternalRef(requestParameters.userUuid, requestParameters.type, requestParameters.externalRefSetDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Protected endpoint without any scope definition
     * @param {DefaultApiTestAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    testAuth(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).testAuth(requestParameters.authorization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: non-existing-scope
     * @summary Protected endpoint with scopes definition that should not exist in any system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    testFakeScopes(options) {
        return (0, exports.DefaultApiFp)(this.configuration).testFakeScopes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-role-read
     * @summary Protected endpoint with scopes definition; Should get jwt token back
     * @param {DefaultApiTestScopesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    testScopes(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).testScopes(requestParameters.authorization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    unAuth(options) {
        return (0, exports.DefaultApiFp)(this.configuration).unAuth(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-group-update
     * @summary Update an existing group
     * @param {DefaultApiUpdateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateGroup(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateGroup(requestParameters.groupUuid, requestParameters.groupUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates password
     * @param {DefaultApiUpdatePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updatePassword(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updatePassword(requestParameters.updatePasswordDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-role-update
     * @summary Updates a role
     * @param {DefaultApiUpdateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateRole(requestParameters.uuid, requestParameters.roleCreateOrUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-role-scope-create, auth-role-scope-delete
     * @summary Updates roles for a scope
     * @param {DefaultApiUpdateRolesForScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateRolesForScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateRolesForScope(requestParameters.uuid, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-scope-update
     * @summary Updates a scope
     * @param {DefaultApiUpdateScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateScope(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateScope(requestParameters.uuid, requestParameters.scopeCreateOrUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scopes: auth-role-scope-delete, auth-role-scope-create
     * @summary Updates scopes for a role
     * @param {DefaultApiUpdateScopesForRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateScopesForRole(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateScopesForRole(requestParameters.uuid, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Required scope: auth-user-update
     * @summary Updates a user
     * @param {DefaultApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateUser(requestParameters.uuid, requestParameters.userCreateOrUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Validate an auth token and return the user ID to which the token belongs
     * @param {DefaultApiValidateAuthTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    validateAuthToken(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).validateAuthToken(requestParameters.tokenValidationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * No scope requirements
     * @summary Verifies user MFA token, registers users device, and returns auth token
     * @param {DefaultApiValidateMfaPasscodeAndRegisterDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    validateMfaPasscodeAndRegisterDevice(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).validateMfaPasscodeAndRegisterDevice(requestParameters.verifyMfaTokenRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * No scope requirements
     * @summary Validates user MFA passcode and returns auth token
     * @param {DefaultApiValidateMfaTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    validateMfaToken(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).validateMfaToken(requestParameters.verifyMfaTokenRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
